import { LocalStorage } from 'quasar'

export default function () {
  return {
    loading: false,
    saving: false,
    user: {},
    checked: false,
    token: LocalStorage.has('auth.token') ? LocalStorage.getItem('auth.token') : '',
    freshLogin: LocalStorage.has('auth.freshLogin') ? LocalStorage.getItem('auth.freshLogin') : false,
    location: false,
    verificationCode: false,
    addresses: false,
    prePhone: null,
    preName: null,
    preCountryCode: null,
    preCountry: null,
    // Array of app languages. Index = server index (Business.menu_language / _User.language).
    // Must stay in sync with cloud/utils.js getIndexFromLocale and Admin's LOCALE_SERVER_INDEX.
    // Use false as placeholder for indices without a supported UI language.
    //new lang add here #2/4
    languages: [
      'en',   // 0
      false,  // 1 — unused
      'he',   // 2
      'es',   // 3
      'de',   // 4
      'fr',   // 5
      'it',   // 6
      'ar',   // 7
      'zh',   // 8
      'ko',   // 9
      'ru',   // 10
      'pt',   // 11
      'tr',   // 12
      'el',   // 13
      'lt',   // 14
      'sk',   // 15
      'hi',   // 16
      'hu',   // 17
      'nl',   // 18
      'nb',   // 19 — Norwegian. BASE code must be 'nb': langOptions groups Quasar packs
              //      by base and Quasar only ships nb-NO. 'no' would never match.
      'ro',   // 20
      'sv',   // 21
      'th',   // 22
      'vi',   // 23
      'ja',   // 24
      'pl',   // 25 — last planned index; the language list ends here
    ],
    //new lang add here #3/4
    flags: {
      'en': 'us',
      'he': 'il',
      'es': 'es',
      'de': 'de',
      'fr': 'fr',
      'it': 'it',
      'ar': 'ae',
      'zh': 'cn',
      'ko': 'kr',
      'ru': 'ru',
      'pt': 'br',
      'tr': 'tr',
      'el': 'gr',
      'lt': 'lt',
      'sk': 'sk',
      'hi': 'in',
      'hu': 'hu',
      'nl': 'nl',
      'nb': 'no',
      'ro': 'ro',
      'sv': 'se',
      'th': 'th',
      'vi': 'vn',
      'ja': 'jp',
      'pl': 'pl',
    },
  }
}
